import { render, staticRenderFns } from "./BulkShow.vue?vue&type=template&id=d763c17c&scoped=true&"
import script from "./BulkShow.vue?vue&type=script&lang=js&"
export * from "./BulkShow.vue?vue&type=script&lang=js&"
import style0 from "./BulkShow.vue?vue&type=style&index=0&id=d763c17c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d763c17c",
  null
  
)

export default component.exports